import locale from "localization";

export const redeemPointsColumns = [
  {
    key: "vipRedemptionIdCashInId",
    text: `${locale.vipRedemptionId}/${locale.cashInId}`,
    style: {
      minWidth: "150px",
    },
  },
  {
    key: "businessNameId",
    text: `${locale.businessName}/${locale.businessId}`,
    style: {
      minWidth: "150px",
    },
  },
  {
    key: "pointsRedeemedAmount",
    text: `${locale.pointsRedeemed}/${locale.amount}`,
    style: {
      minWidth: "120px",
    },
  },
  {
    key: "dateCreatedFulfilledDate",
    text: `${locale.dateCreated}/${locale.fulfilledDate}`,
    style: {
      minWidth: "120px",
    },
  },
  {
    key: "redemptionMethod",
    text: locale.redemptionMethod,
    style: {
      minWidth: "120px",
    },
  },
  {
    key: "status",
    text: locale.status,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "actions",
    text: locale.actions,
    style: {
      minWidth: "60px",
    },
  },
];
